import { Stack, Avatar, Typography, alpha, useTheme, Paper, Box } from '@mui/material';

interface MetricsSectionHeadingProps {
    icon: React.ReactNode;
    title: string;
    children: React.ReactNode;
}

export const MetricsSectionHeading = ({ icon, title, children }: MetricsSectionHeadingProps) => {
    const theme = useTheme();
    return (
        <Paper
            elevation={2}
            sx={{
                mb: 4,
                borderRadius: 3,
                overflow: 'hidden',
                border: `1px solid ${alpha(theme.palette.divider, 0.6)}`,
            }}
        >
            {/* Section header bar */}
            <Stack
                direction="row"
                sx={{
                    alignItems: 'center',
                    gap: 1.5,
                    px: 2.5,
                    py: 1.5,
                    borderBottom: `1px solid ${alpha(theme.palette.divider, 0.5)}`,
                    bgcolor: alpha(theme.palette.primary.main, 0.04),
                }}
            >
                <Avatar
                    sx={{
                        bgcolor: alpha(theme.palette.primary.main, 0.15),
                        color: 'primary.main',
                        width: 32,
                        height: 32,
                    }}
                >
                    {icon}
                </Avatar>
                <Typography variant="h6" fontWeight={600}>
                    {title}
                </Typography>
            </Stack>

            {/* Section content */}
            <Box sx={{ p: 2.5 }}>{children}</Box>
        </Paper>
    );
};
